<template>
  <AppCoupon ad_mold="coupon_for_newer" />
</template>

<script>
import AppCoupon from '@/views/ad/components/app-coupon/app-coupon';
export default {
  name: 'AppNewerGiftCoupon',
  components: {
    AppCoupon,
  },
};
</script>
